import { Component } from '@angular/core';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { UITableBaseColumn } from '../table-base-column/table-base-column.component';
import { LocalizationPipe } from '@shared/modules/localization';

@Component({
  selector: 'ui-table-header-column',
  templateUrl: './table-header-column.component.html',
  styleUrls: ['./table-header-column.component.scss'],
  standalone: true,
  imports: [NzTypographyModule, LocalizationPipe],
})
export class UITableHeaderColumn extends UITableBaseColumn {}
